import { Injectable } from '@angular/core';
import { LocaleHelperService } from '@finder/shared/services/locale-service/locale-helper.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Injectable()
export class WebLinkValidationService {

    constructor(
        private localeHelper: LocaleHelperService,
        private windowRef: WindowRef
    ) {}

    validateWebLink(webLink): void {
        if (!webLink) {
            // if there is no webLink in service just return.
            return;
        }

        webLink = this.normalizeHref(webLink);
        const location = this.windowRef.nativeWindow.location;
        const history = this.windowRef.nativeWindow.history;
        const currentPath = this.normalizeHref(location.pathname);

        /**
         * Check to see if the current browser uri is contained within the webLink property.
         * This may include a modal deep link.
         * eg
         * webLink: /dining/hollywood-studios/50s-prime-time-cafe
         * currentPath: /dining/hollywood-studios/50s-prime-time-cafe/availability-modal
         */
        if (!currentPath.includes(webLink)) {
            // Get proper URL
            const properUrl = new URL(
                `${webLink}${location.search || ''}${location.hash || ''}`,
                location.origin
            );

            // Fix the browser URL bar
            history.replaceState({}, null, properUrl.href);
        }
    }

    /**
     * Turns a href into a "normalized" path
     * Input:   https://domain.com/this/that/
     * Output:  /this/that
     */
    private normalizeHref(webLink: string): string {
        // trim (for safety)
        webLink = webLink.trim();

        // remove domain
        if (webLink.startsWith('http')) {
            webLink = new URL(webLink).pathname;
        }

        // remove trailing slash
        webLink = this.removeLastSlash(webLink);

        // remove locale
        webLink = this.localeHelper.stripLocale(webLink);

        return webLink;
    }

    private removeLastSlash(webLink): string {
        // remove last '/'
        return webLink.replace(/\/$/g, '');
    }
}
